import type { TranslationKey } from "../locales";
import type { ProtocolPriorityType } from "../types";

/**
 * This function returns the translation key for a given protocol priority.
 * @param priority
 * @returns
 */
export function getProtocolPriorityTranslationKey(priority: ProtocolPriorityType): TranslationKey {
	switch (priority) {
		case "low":
			return "priority.low";
		case "medium":
			return "priority.medium";
		case "high":
			return "priority.high";
		case "very-high":
			return "priority.very_high";
		case "custom":
			return "priority.custom";
	}
}
